module.exports = __webpack_public_path__ + "static/media/bo-sot-tieu.45b92f0a.jpg";